<script setup>
const currentYear = new Date().getFullYear();
</script>

<template>
    <footer class="border-t bg-white border-gray-100 dark:bg-gray-800 dark:border-gray-700/70">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                <!-- Logo and Description -->
                <div class="flex flex-col items-center text-center md:text-left md:items-start space-y-4">
                    <!-- Logo -->
                    <NuxtLink to="/" class="flex items-center">
                        <NuxtImg src="/images/kasphub-logo-light.png" alt="KaspHub Logo" height="36" width="130" loading="lazy" class="transform transition-all duration-300 hover:scale-105 dark:hidden" />
                        <NuxtImg src="/images/kasphub-logo-dark.png" alt="KaspHub Logo" height="36" width="130" loading="lazy" class="transform transition-all duration-300 hover:scale-105 hidden dark:block" />
                    </NuxtLink>

                    <!-- Description -->
                    <p class="text-gray-500 dark:text-gray-400 text-sm">
                        Your go-to resource for Kaspa market metrics, comparisons, and technical analysis.
                    </p>

                    <!-- About Page Link -->
                    <a href="/about" class="text-gray-500 font-semibold hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors duration-200">
                        About
                    </a>
                </div>

                <!-- Contact -->
                <div class="text-center">
                    <h3 class="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
                        Contact
                    </h3>
                    <div class="space-y-2">
                        <a href="mailto:contact@kasphub.com" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-300 flex items-center justify-center gap-2">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            contact@kasphub.com
                        </a>
                    </div>
                </div>

                <!-- Social -->
                <div class="text-center">
                    <h3 class="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
                        Follow Us
                    </h3>
                    <div class="flex justify-center space-x-4">
                        <a href="https://x.com/KaspHub" target="_blank" rel="noopener noreferrer" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-300" aria-label="Follow us on X">
                            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" role="img" aria-hidden="true">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Copyright -->
            <div class="mt-8 pt-8 border-t border-gray-100 dark:border-gray-700">
                <p class="text-center text-gray-400 dark:text-gray-500 text-sm">
                    © {{ currentYear }} KaspHub. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
</template>